import Controller from '@ember/controller';

export default class RubricsController extends Controller {}
